import React from "react";
import "./CustomTooltip.css";

interface CustomTooltipProps {
  conditionToShow?: boolean;
  tooltip?: React.ReactNode;
  children: React.ReactNode;
}

const CustomTooltip: React.FC<CustomTooltipProps> = (props) => {
  return (
    <div style={{ position: "relative" }}>
      {props?.conditionToShow && (
        <div className="custom-tooltip-wrapper">
          {props.tooltip}
          <div className="custom-tooltip-arrow" />
        </div>
      )}
      {props.children}
    </div>
  );
};

export default CustomTooltip;
